export const ROLES_OPTION = [
  {
    label: "Admin",
    value: "ADMIN",
  },
  { label: "Individual", value: "INDIVIDUAL" },
  { label: "Establishment", value: "ESTABLISHMENT" },
];

export const UNITS = [
  {
    label: "Quantity",
    options: [
      {
        value: "ea",
        names: ["ea"],
        label: "each (ea)",
        abbreviation: "ea",
      },
    ],
  },
  {
    label: "Weight",
    options: [
      {
        value: "kg",
        names: ["kg"],
        label: "kilograms (kg)",
        abbreviation: "kg",
      },
      {
        value: "gr",
        names: ["g", "gr"],
        label: "grams (g)",
        abbreviation: "g",
      },
      {
        value: "mg",
        names: ["mg"],
        label: "milligrams (mg)",
        abbreviation: "mg",
      },
      {
        value: "oz",
        names: ["oz", "oz."],
        label: "ounces (oz)",
        abbreviation: "oz",
      },
      {
        value: "mcg",
        names: ["mg", "µg"],
        label: "microgram (µg)",
        abbreviation: "µg",
      },
      {
        value: "t",
        names: ["t", "T"],
        label: "tons (t)",
        abbreviation: "t",
      },
      {
        value: "lb",
        names: ["lb", "lb."],
        label: "pounds (lb)",
        abbreviation: "lb",
      },
      {
        value: "LT",
        names: ["LT", "L.T."],
        label: "long tons (LT)",
        abbreviation: "LT",
      },
    ],
  },
  {
    label: "Volume",
    options: [
      {
        value: "mL",
        names: ["mL"],
        label: "milliliter (mL)",
        abbreviation: "mL",
      },
      {
        value: "cL",
        names: ["cL"],
        label: "centiliter (cL)",
        abbreviation: "cL",
      },
      {
        value: "dL",
        names: ["dL"],
        label: "deciliter (dL)",
        abbreviation: "dL",
      },
      {
        value: "L",
        names: ["L"],
        label: "liter (L)",
        abbreviation: "L",
      },
    ],
  },
];

export const PRODUCT_CATEGORIES = [
  {
    label: "Primary",
    options: [
      {
        label: "Meat",
        value: "meat",
      },
      {
        label: "Seafoods",
        value: "seafoods",
      },
      {
        label: "Vegetables",
        value: "vegetables",
      },
      {
        label: "Fruits",
        value: "fruits",
      },
      {
        label: "Mixes & Seasonings",
        value: "mixes_seasonings",
      },
      {
        label: "Agri-Products",
        value: "agri_products",
      },
    ],
  },
  {
    label: "Others",
    options: [
      {
        label: "Baby Needs",
        value: "baby_needs",
      },
      {
        label: "Baking Aid",
        value: "baking_aid",
      },
      {
        label: "Beverages",
        value: "beverages",
      },
      {
        label: "Body Care",
        value: "body_care",
      },
      {
        label: "Bread",
        value: "bread",
      },
      {
        label: "Breakfast",
        value: "break_fast",
      },
      {
        label: "Car Accessory",
        value: "car_accessory",
      },
      {
        label: "Cleaning Aid",
        value: "cleaning_aid",
      },
      {
        label: "Cookies / Biscuits / etc.",
        value: "cockies_biscuits_etc",
      },
      {
        label: "Corn / Nuts / Seeds",
        value: "corn_nuts_seeds",
      },
      {
        label: "Dairy",
        value: "dairy",
      },
      {
        label: "Delicacies",
        value: "delicacies",
      },
      {
        label: "Dry Foods",
        value: "dry_foods",
      },
      {
        label: "Facial Care",
        value: "facial_care",
      },
      {
        label: "Fresh Goods",
        value: "fresh_goods",
      },
      {
        label: "Frozen Fish / Seafood",
        value: "frozen_fish_seafood",
      },
      {
        label: "Frozen Food",
        value: "frozen_food",
      },
      {
        label: "Frozen Meat",
        value: "frozen_meat",
      },
      {
        label: "Hair Care",
        value: "hair_care",
      },
      {
        label: "Home Furniture",
        value: "home_furniture",
      },
      {
        label: "Household Cleaning",
        value: "household_cleaning",
      },
      {
        label: "Insecticides",
        value: "insecticides",
      },
      {
        label: "Medicare",
        value: "medicare",
      },
      {
        label: "Milk",
        value: "milk",
      },
      {
        label: "Processed Fish & Foods",
        value: "processed_fish_foods",
      },
      {
        label: "Oils",
        value: "oil",
      },
      {
        label: "Paper / Plastic / Packaging",
        value: "paper_plastic_packaging",
      },
      {
        label: "Pasta",
        value: "pasta",
      },
      {
        label: "Pet Products",
        value: "pet_products",
      },
      {
        label: "Processed Fruits",
        value: "processed_fruits",
      },
      {
        label: "Processed Meat",
        value: "processed_meat",
      },
      {
        label: "Processed Vegetables",
        value: "processed_vegetables",
      },
      {
        label: "Sanitary Care",
        value: "sanitary_care",
      },
      {
        label: "Snacks",
        value: "snacks",
      },
      {
        label: "Toiletries",
        value: "toiletries",
      },
      {
        label: "Utility Plastic Ware",
        value: "utility_plastic_ware",
      },
    ],
  },
];
